import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Radial from "../../Charts/Radial";
import { ChartTitle } from "../styles/employer-analytics-styles";
import offerToPlacementTypes from "../types/offerToPlacementTypes";
import {
  Wrapper,
  Charts,
  Chart,
  ChartName,
} from "../styles/offer-to-placement-styles";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";

interface IOfferToPlacementProps {
  offerToPlacement: {
    yourCompany: number;
    hiringHub: number;
  };
  pdfExport?: boolean;
  pipelineSelected?: boolean;
  offerToPlacementWidgetLoader: boolean;
}

export const OfferToPlacement: FunctionComponent<IOfferToPlacementProps> = ({
  offerToPlacement,
  pdfExport,
  pipelineSelected,
  offerToPlacementWidgetLoader,
}) => {
  const yourCompanyOptions = {
    series: [offerToPlacement.yourCompany],
    options: {
      height: 170,
      chart: {
        offsetY: -12,
        type: "radialBar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: "65%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
          },
          track: {
            background: "#fff",
            strokeWidth: "95%",
            margin: 0,
            dropShadow: {
              enabled: true,
              top: -2,
              left: 0,
              blur: 4,
              opacity: 0.2,
            },
          },
          dataLabels: {
            show: true,
            name: {
              offsetY: 0,
              show: true,
              color: "#888",
              fontSize: "17px",
            },
            value: {
              formatter: (val) => {
                const value = parseInt(val, 10) || 0;
                return `${value}%`;
              },
              color: "#111",
              offsetY: -8,
              fontSize: "22px",
              show: true,
            },
          },
        },
      },
      colors: ["rgb(0, 143, 251)"],
      labels: [""],
    },
  };

  const hiringHubOptions = {
    series: [offerToPlacement.hiringHub],
    options: {
      height: 170,
      chart: {
        offsetY: -12,
        type: "radialBar",
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        radialBar: {
          startAngle: 0,
          endAngle: 360,
          hollow: {
            margin: 0,
            size: "65%",
            background: "#fff",
            image: undefined,
            imageOffsetX: 0,
            imageOffsetY: 0,
            position: "front",
          },
          track: {
            background: "#fff",
            strokeWidth: "95%",
            margin: 0,
            dropShadow: {
              enabled: true,
              top: -2,
              left: 0,
              blur: 4,
              opacity: 0.2,
            },
          },
          dataLabels: {
            show: true,
            name: {
              offsetY: 0,
              show: true,
              color: "#888",
              fontSize: "17px",
            },
            value: {
              formatter: (val) => {
                const value = parseInt(val, 10) || 0;
                return `${value}%`;
              },
              color: "#111",
              offsetY: -8,
              fontSize: "22px",
              show: true,
            },
          },
        },
      },
      colors: ["#79D9D9"],
      labels: [""],
    },
  };

  /* const industryAvgOptions = {
   *   series: [offerToPlacement.industryAvg],
   *   options: {
   *     height: 170,
   *     chart: {
   *       offsetY: -12,
   *       type: 'radialBar',
   *       toolbar: {
   *         show: false,
   *       },
   *     },
   *     plotOptions: {
   *       radialBar: {
   *         startAngle: 0,
   *         endAngle: 360,
   *         hollow: {
   *           margin: 0,
   *           size: '65%',
   *           background: '#fff',
   *           image: undefined,
   *           imageOffsetX: 0,
   *           imageOffsetY: 0,
   *           position: 'front',
   *         },
   *         track: {
   *           background: '#fff',
   *           strokeWidth: '95%',
   *           margin: 0,
   *           dropShadow: {
   *             enabled: true,
   *             top: -2,
   *             left: 0,
   *             blur: 4,
   *             opacity: 0.2,
   *           },
   *         },
   *         dataLabels: {
   *           show: true,
   *           name: {
   *             offsetY: 0,
   *             show: true,
   *             color: '#888',
   *             fontSize: '17px',
   *           },
   *           value: {
   *             formatter: (val) => {
   *               const value = parseInt(val, 10) || 0;
   *               return `${value}%`;
   *             },
   *             color: '#111',
   *             offsetY: -8,
   *             fontSize: '22px',
   *             show: true,
   *           },
   *         },
   *       },
   *     },
   *     colors: ['rgb(0, 227, 150)'],
   *     labels: [''],
   *   },
   * }; */

  return (
    <Wrapper
      className="animated fadeIn delay-4"
      pdfExport={pdfExport}
      pipelineSelected={pipelineSelected}
    >
      <AnalyticsWidgetLoading
        text="Updating..."
        active={offerToPlacementWidgetLoader}
      />
      <ChartTitle data-test-id="offer-to-placement-charts-title">
        Offer to Placement (12 month average)
      </ChartTitle>
      <Charts data-test-id="offer-to-placement-charts" pdfExport={pdfExport}>
        <Chart className="animated fadeIn delay-4">
          <Radial
            graphOptions={yourCompanyOptions}
            dataTestId="your-company-otp"
          />
          <ChartName>Your company</ChartName>
        </Chart>
        <Chart className="animated fadeIn delay-4">
          <Radial
            graphOptions={hiringHubOptions}
            dataTestId="your-company-otp"
          />
          <ChartName>Hiring Hub</ChartName>
        </Chart>
        {/* <Chart className='animated fadeIn delay-4'>
            <Radial
            graphOptions={industryAvgOptions}
            dataTestId='industry-avg-otp'
            />
            <ChartName>Industry Average</ChartName>
            </Chart> */}
      </Charts>
    </Wrapper>
  );
};

OfferToPlacement.propTypes = {
  offerToPlacement: offerToPlacementTypes,
  pdfExport: PropTypes.bool,
  pipelineSelected: PropTypes.bool,
  offerToPlacementWidgetLoader: PropTypes.bool.isRequired,
};

OfferToPlacement.defaultProps = {
  pdfExport: null,
  pipelineSelected: null,
  offerToPlacement: {
    yourCompany: 0,
    hiringHub: 0,
  },
};

interface IReduxState {
  employerAnalytics: {
    chartsData: {
      offerToPlacement: {
        yourCompany: number;
        hiringHub: number;
      };
    };
    offerToPlacementWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  offerToPlacement: state.employerAnalytics.chartsData.offerToPlacement,
  offerToPlacementWidgetLoader:
    state.employerAnalytics.offerToPlacementWidgetLoader,
});

export default connect(mapStateToProps, {})(OfferToPlacement);
